import React from 'react';
import './TVSkeleton.css';

/**
 * Shimmer skeleton that mirrors the TV single-view layout
 * (location card on left, map + forecast strip on right).
 */
function TVSkeleton() {
  return (
    <div className="tv-skeleton">
      {/* Left column – location card placeholder */}
      <div className="tv-skel-card">
        <div className="tv-skel-line tv-skel-city" />
        <div className="tv-skel-circle" />
        <div className="tv-skel-line tv-skel-temp" />
        <div className="tv-skel-line tv-skel-desc" />
        <div className="tv-skel-metrics">
          <div className="tv-skel-metric" />
          <div className="tv-skel-metric" />
          <div className="tv-skel-metric" />
          <div className="tv-skel-metric" />
        </div>
      </div>

      {/* Right column – map + forecast */}
      <div className="tv-skel-right">
        <div className="tv-skel-map" />
        <div className="tv-skel-forecast">
          {[...Array(5)].map((_, i) => (
            <div key={i} className="tv-skel-day">
              <div className="tv-skel-line tv-skel-day-label" />
              <div className="tv-skel-small-circle" />
              <div className="tv-skel-line tv-skel-day-temp" />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default TVSkeleton;
